import React from 'react';
import { Form, Input, Select, Button, Row, Col } from 'antd';
import { SearchOutlined, FilterOutlined } from '@ant-design/icons';

const { Option } = Select;

const UserFilters = ({ onSearch, onFilterChange, loading }) => {
  const [form] = Form.useForm();

  const handleSearch = (values) => {
    onSearch(values);
  };

  const handleReset = () => {
    form.resetFields();
    onFilterChange({});
  };

  return (
    <Form
      form={form}
      onFinish={handleSearch}
      layout="vertical"
    >
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Form.Item name="search" label="Rechercher">
            <Input 
              placeholder="Nom, email, téléphone..." 
              prefix={<SearchOutlined />}
            />
          </Form.Item>
        </Col>
        
        <Col xs={24} sm={12} md={8} lg={6}>
          <Form.Item name="role" label="Rôle">
            <Select placeholder="Tous les rôles" allowClear>
              <Option value="admin">Administrateur</Option>
              <Option value="manager">Manager</Option>
              <Option value="leader">Leader</Option>
              <Option value="user">Utilisateur</Option>
            </Select>
          </Form.Item>
        </Col>
        
        <Col xs={24} sm={12} md={8} lg={6}>
          <Form.Item name="status" label="Statut">
            <Select placeholder="Tous les statuts" allowClear>
              <Option value="active">Actif</Option>
              <Option value="suspended">Suspendu</Option>
              <Option value="banned">Banni</Option>
              <Option value="pending">En attente</Option>
            </Select>
          </Form.Item>
        </Col>
        
        <Col xs={24} sm={12} md={8} lg={6}>
          <Form.Item name="verification_status" label="Vérification">
            <Select placeholder="Tous les statuts" allowClear>
              <Option value="verified">Vérifié</Option>
              <Option value="pending">En attente</Option>
              <Option value="rejected">Rejeté</Option>
            </Select>
          </Form.Item>
        </Col>
        
        <Col xs={24} sm={24} md={24} lg={24}>
          <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
            <Button 
              type="primary" 
              htmlType="submit" 
              icon={<FilterOutlined />}
              loading={loading}
            >
              Appliquer les filtres
            </Button>
            <Button onClick={handleReset}>
              Réinitialiser
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
};

export default UserFilters;